var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('OrdersInboundCreateContent',{attrs:{"ordersInbound":_vm.ordersInbound,"disabledWarehouse":_vm.disabledWarehouse},on:{"changeUser":_vm.changeUser,"create":_vm.save,"saveInDraft":_vm.saveInDraft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }